/**
 * Merge / split / links / snooze contracts (T-036 · 04 §5, §9 · W3-CONTRACTS §8)
 * `Ticket`/`TicketSummary` อ้างจาก index ผ่าน z.lazy (index export ไฟล์นี้ — กัน circular TDZ เหมือน handoff.ts)
 */
import { z } from "zod";
import { Ticket, TicketSummary } from "./index.ts";

export const MergeInput = z.object({
  into: z.string().min(1),
  expected_version: z.number().int(),
});
export type MergeInput = z.infer<typeof MergeInput>;

export const SplitInput = z.object({
  message_ids: z.array(z.uuid()).min(1).max(500),
  service_code: z.string().regex(/^[A-Z0-9]{2,4}$/).optional(),
  team_id: z.uuid().optional(),
  subject: z.string().trim().min(1).max(998).optional(),
  move_internal: z.boolean().optional(),
});
export type SplitInput = z.infer<typeof SplitInput>;

export const SplitResult = z.object({
  source: z.lazy(() => Ticket),
  new: z.lazy(() => Ticket),
});
export type SplitResult = z.infer<typeof SplitResult>;

/** `blocked_by` = ทาง API เก็บเป็น `blocks` กลับทิศ (schema จริงไม่มี blocked_by — W3-CONTRACTS §8) */
export const TicketLinkType = z.enum(["relates", "blocks", "blocked_by", "duplicates"]);
export type TicketLinkType = z.infer<typeof TicketLinkType>;

export const LinkInput = z.object({
  type: TicketLinkType,
  /** ticket public id ปลายทาง */
  target: z.string().min(1),
});
export type LinkInput = z.infer<typeof LinkInput>;

export const TicketLink = z.object({
  type: TicketLinkType,
  ticket: z.lazy(() => TicketSummary),
});
export type TicketLink = z.infer<typeof TicketLink>;

export const TicketLinkList = z.object({ items: z.array(TicketLink) });
export type TicketLinkList = z.infer<typeof TicketLinkList>;

export const SnoozeInput = z.object({
  /** [T-054] scope:"me" + until:null = ถอน per-user snooze · scope:"card" (default) ต้องมี until อนาคต */
  until: z.iso.datetime().nullable(),
  /** scope:"card" บังคับ (ตรวจใน snoozeTicket — 422 เมื่อไม่ส่ง) · scope:"me" ไม่ใช้ */
  expected_version: z.number().int().optional(),
  /** card = snooze ทั้งการ์ด (T-036) · me = ซ่อนจาก view=mine ของคนนั้นเท่านั้น (T-054) */
  scope: z.enum(["card", "me"]).default("card"),
});
export type SnoozeInput = z.infer<typeof SnoozeInput>;
